import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Button,
  Tab,
  Tabs,
  Switch,
} from "@mui/material";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import AddTemplate from "../../Modals/addTemplate";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Settings = () => {
  const navigate = useNavigate();
  const [rowsMessage, setRowsMessage] = useState([
    {
      id: 1,
      title: "Welcome Message",
      message1: "Welcome to our new users!",
      enabled: true,
    },
    {
      id: 2,
      title: "Maintenance Alert",
      message1: "System will be down from 2 AM - 4 AM",
      enabled: false,
    },
  ]);
  const toggleStatus = (id: number) => {
    setRowsMessage(prev =>
      prev.map(row =>
        row.id === id ? { ...row, enabled: !row.enabled } : row
      )
    );
  };
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="main_title">
        <h1>Settings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Settings
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Templates" {...a11yProps(0)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..." />
              </Box>
            </div>

            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen1(true)}
              >
                <AddIcon /> Add
              </Button>
            </div>
          </div>

          <TableContainer className="table_container" sx={{ marginTop: 4 }}>
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsMessage.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      <Typography fontWeight="bold">{index + 1}</Typography>
                    </TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>{row.message1}</TableCell>
                    <TableCell>
                      <Switch
                        checked={row.enabled}
                        onChange={() => toggleStatus(row.id)}
                        color="primary"
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </CustomTabPanel>
      </div>
      <AddTemplate open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
    </>
  );
};

export default Settings;
